import React from 'react';
import { css, styled } from 'styled-components';
import { Box, HStack, MIN_WIDTH, useMedia } from '@vivaahealth/design-system';

interface RowProps {
  hideIconContainer?: boolean;
  Icon?: React.ComponentType<any>;
  children: React.ReactNode;
}

const IconContainer = styled.div`
  flex-shrink: 0;
  width: 16px;
`;

interface EntryWrapperProps {
  numColumns: number;
  children: React.ReactNode;
}

const StyledEntryWrapper = styled.div<EntryWrapperProps>`
  // We need to account for gap when setting flex-basis
  flex-basis: calc(${({ numColumns }) => 100 / numColumns}% - 8px);

  ${({ theme }) => theme.breakpoints.down('sm')} {
      flex-basis: calc(${({ numColumns }) => 100 / numColumns}% - 4px);
    }
  };
  // This prevents multi-column layouts from wrapping in their containers
  ${(props) =>
    props.numColumns > 1 &&
    css`
      & > * {
        white-space: nowrap;
      }
    `}
`;

const EntryWrapper = ({ numColumns, children }: EntryWrapperProps) => {
  return (
    <StyledEntryWrapper numColumns={numColumns}>{children!}</StyledEntryWrapper>
  );
};

const Row: React.FC<RowProps> = ({
  hideIconContainer = false,
  Icon,
  children,
}) => {
  const isDesktop = useMedia(MIN_WIDTH.MD);

  const childrenArray = React.Children.toArray(children);

  return (
    <HStack width={'100%'} height={'auto'} gap={8}>
      {!hideIconContainer && (
        <IconContainer>
          {!!Icon && (
            <Box marginTop={isDesktop ? 4 : 2}>
              <Icon size="medium" color="#737373" />
            </Box>
          )}
        </IconContainer>
      )}
      <HStack
        width={'100%'}
        height={'100%'}
        flexWrap={'wrap'}
        gap={isDesktop ? 16 : 8}
      >
        {childrenArray.map((child, index, arr) => (
          <EntryWrapper key={index} numColumns={arr.length}>
            {child}
          </EntryWrapper>
        ))}
      </HStack>
    </HStack>
  );
};

export default Row;
